import { Injectable } from '@angular/core';
import Web3 from "web3";
import { environment } from 'src/environments/environment';
import { CommonService } from './common.service';
import { StorageService } from './storage.service';
import { readContract } from '@wagmi/core';
const abi = require('src/contracts/abi/pdogv1.json');
const migrationAbi = require('src/contracts/abi-dev/migrator.json');
// Set web3
let web3, contract;

@Injectable({
  providedIn: 'root'
}) 
export class V1ContractService {
  provider: string;
  constructor(private commonService: CommonService, private storageService: StorageService) {
    this.provider = JSON.parse(this.storageService.getItem('account')) != null ? JSON.parse(this.storageService.getItem('account')).provider : "";
  }

  /**
   * Gets contract address
   */
  async getContractAddress(){
    return await readContract({
      address: environment.MIGRATOR_ADDRESS as any,
      abi: migrationAbi,
      functionName: 'getlegacyToken',
      args: []
    }); 
  }

  /**
   * Gets decimals
   * @param v1Address 
   * @returns  
   */
  async getDecimals(v1Address) {
    const decimals = await readContract({
      address: v1Address,
      abi: abi,
      functionName: 'decimals',
      args: []
    })
    return decimals;
  }

  /**
   * Gets balance
   * @param {string} address 
   * @returns  
   */
  async getBalance(address:string,v1Address) {
    const balance = await readContract({
      address: v1Address,
      abi: abi,
      functionName: 'balanceOf',
      args: [address]
    })
    return balance;
  }

  
  /**
   * Gets symbol
   * @param  v1Address
   * @returns  
   */
  async getSymbol(v1Address) {
    const symbol = await readContract({
      address: v1Address,
      abi: abi,
      functionName: 'symbol',
      args: []
    })
    return symbol;
  }
  /**
   * Gets allowance
   * @param {string} ownerAddr 
   * @param {string} spenderAddr 
   * @param v1Address 
   * @returns  
   */
  async getAllowance(ownerAddr:string, spenderAddr:string,v1Address) {
    const allowance = await readContract({
      address: v1Address,
      abi: abi,
      functionName: 'allowance',
      args: [ownerAddr, spenderAddr]
    })
    return allowance;
  }
}
